export default {
  button: {
    sendMail: "Envoi mail",
    cancel: 'Annuler',
    confirm: 'Confirmer',
    add: 'Ajouter',
    settings: 'Propriétés',
    close: 'Fermer',
    delete: 'Supprimer',
    save: 'Enregistrer',
    edit: 'Modifier',
    view: 'Details',
    statistics: 'Statistiques',
    infos: 'Informations du direct',
    export: 'Liste des inscrits',
    export_questions: 'Liste des questions',
    diffusion: 'Diffuser',
    comments: 'Liste des commentaires',
    encoding: 'Encodeur externe',
    done: 'Ok',
    link_export: "lien d'export",
    send_invitations: 'Envoyer des invitations',
    send_group_mails: 'Liste des groupes',
    send: 'Envoyer',
    share: "Ajouter partage d'écran",
    validate: 'Valider',
    download: "Télécharger le fichier de partage d'écran",
    show_live: 'Afficher le direct',
    ok: 'Ok',
    add_emails: 'Ajouter E-mails',
    return: 'Retour',
    copy: 'Copier',
    visualize: 'Visualiser',
    restart: 'Rediffuser',
    upload: 'Télécharger',
    restore: 'Restaurer',
    flow: 'Flux'
  },
  parameters: {
    period: {
      period: 'Période',
      week: 'Semaine',
      month: 'Mois',
      trimester: 'Trimestre',
      semester: 'Semestre',
      year: 'Année',
    },
    search: {
      title: 'Titre',
      description: 'Description',
      search: "Chercher"
    },
    filter: {
      contributors: 'Contributeur',
      date: 'Date',
      period: 'Période',
      search: 'Rechercher',
      reset: 'Réinitialiser',
      no_options: 'Désolé, aucune option correspondante',
      no_contributor: 'Désolé, aucun contributeur ne correspond à votre recherche',

    },
    select: {
      selectOption: 'Sélectionner',

    }
  },
  table: {
    pagination: {
      first: 'Premier',
      last: 'Dernier',
      prev: 'Précédent',
      next: 'Suivant',
      show: 'Afficher',
      elements: 'éléments',
      elementPerPage: "éléments par page"
    },
    list: {
      id: 'Id',
      preview: 'Aperçu',
      title: 'Titre',
      description: 'Description',
      active: 'Active',
      statut:"Statut",
      date: 'Date',
      actions: 'Actions',
      idInscrit: "ID",
      nom: "Nom",
      email: "Email",
      entreprise: "Entreprise",
      participation: "Participation",
      subscribersList: "Liste d'inscrits"
    },
    empty: "Désolé, il n'y a rien à afficher ici.",
  },
  modal: {
    groups: "Groupes",
    hour: "Heure",
    date: "Date",
    users: "Utilisateurs",
    moderators: "Modérateurs",
    send_email: "Envoyer un email",
    EnterEmails: "Saisissez les e-mails et appuyez sur Entrée",
    select_groups: "Sélectionner le groupe d’utilisateurs de la liste ci-dessous",
    about: 'A propos',
    error: 'Veuillez vérifier tous les champs',
    errorDuplicate: "L'intervenant a été déjà mis à jour avec les mêmes informations.",
    errorEmail: "Adresse e-mail invalide",
    errorEmailDuplicated: "L'e-mail existe déjà",
    errorUpload: "Erreur lors du téléchargement de l'image",
    success: "Un intervenant a été ajouté avec succès",
    successUpdate: "L'intervenant a été modifié avec succès",
    delete: {
      selection: {
        title: 'Voulez-vous supprimer cette sélection de directs ?',
        subtitle: 'Les éléments sélectionnés seront supprimés.',
        confirm_title: 'Supprimé',
        confirm_msg: 'La suppression est effectuée avec succès.',
        cancel_title: 'Annuler',
        cancel_msg: 'Vous avez annulé la suppression',
        btn_confirm: 'Supprimer',
        btn_cancel: 'Annuler',
      },
      form: {
        subtitle: "L'élément sélectionné sera supprimé.",
      },
      title: 'Voulez-vous supprimer ce direct ?',
      subtitle: ' sera supprimé.',
      confirm_title: 'Supprimé',
      confirm_msg: 'La suppression est effectuée avec succès.',
      cancel_title: 'Annuler',
      cancel_msg: 'Vous avez annulé la suppression',
      btn_confirm: 'Supprimer',
      btn_cancel: 'Annuler',
    },

    edit: {
      title: 'Modifier le titre de cet écran',
      error_msg: 'Entrer un nom',
      btn_confirm: 'Modifier',
      btn_cancel: 'Annuler',
    },
    view: {
      title: 'Détail du direct ',
      btn_cancel: 'Fermer',
      params: {
        title: 'Titre',
        id: 'Identifiant',
        description: 'Description',
        tags: 'Tags',
        date: 'Date',
        private: 'Privé',
        automatic_share: 'Publier automatiquement',
        active: 'Actif',
        vignette: 'Vignette',
        like: "J'aime",
        poll: 'Sondage',
        registration: 'Inscription des abonnées',
        send_mails: 'Envoi des commentaires',
        share_file: 'Documents partagés',
        screen_share: "Partage d'écran",
        config: 'Configuration par défaut',
        yes: 'Oui',
        no: 'Non',
      },
    },
    setting: {
      diffusion: {
        title: 'Diffusion',
        endless: 'En cours',
        archived: 'Archivés',
        all: 'Tout',
        upcoming: 'A venir',
        trash: 'Corbeille',
      },
    },
    infos: {
      title: 'Paramètres de diffusion ',
      btn_cancel: 'Fermer',
      url_diffusion: 'Diffusion',
      name_flow: 'Clé du flux',
      login: 'Login',
      pass: 'Mot de Passe',
      link: 'Lien',
      key: 'Clé'
    },
    export: {
      title: "Liens d'export du direct : ",
      permalink: 'Permalien',
      permalink_participant: 'URL intervenant',
      standAlone: 'Url autonome',
      standAlone_permalink: 'URL auditeur',
      standAlone_permalink_participant: 'URL participant',
      embed: "Lien d'intégration",
      moderator: "Lien modérateur",
      journalist: "Lien prompteur",
      url: "Url d'export",
      copy: 'Copier',
    },
    send_invitations: {
      title: 'Envoyer des invitations',
    },
    send_group_mails: {
      title: 'Envoyer liste des groupes',
      insert_mails: {
        title: 'Ajouter E-mails',
        placeholder: 'E-mails',
        label: 'Liste des emails',
        text: 'Veuillez insérer les e-mails dans le champ suivant',
      },
      send_mails: {
        title: 'Envoie aux clients',
        text: "Sélectionnez un groupe d'e-mails dans la liste ci-dessous",
        groupLabel: 'Liste des groupes',
        mailLabel: 'Liste des E-mails',
      },
    },
    screen_share: {
      title: 'Type de sortie',
      type: 'Sélectionner le type nde sortie',
    },
    show_archived_live: {
      title: 'Direct archivé',
      not_found: "Direct n'existe pas",
      not_transcripted: "La vidéo n’est pas encore encodée",
    },
    direct: {
      start: {
        title: "Commencer le direct",
        subtitle: "Voulez-vous commencer le direct?",
      },
      stop: {
        title: "Arrêter le direct",
        subtitle: "Voulez-vous arrêter le direct?",
      },
      archiving: {
        title: {
          simple: "Voulez-vous vraiment placer ce direct dans la corbeille ?",
          multi: 'Voulez-vous vraiment placer ces directs dans la corbeille ?',
        },
        subtitle: {
          simple: " sera placé dans la corbeille",
          multi: " seront placés dans la corbeille"
        },
        success: {
          simple: ' est placé dans la corbeille',
          multi: ' sont placés dans la corbeille'
        }
      },
      restoring: {
        title: {
          simple: "Voulez-vous restaurer ce direct  ?",
          multi: 'Voulez-vous restaurer ces directs ?',
        },
        subtitle: {
          simple: " sera restauré",
          multi: " seront restaurés"
        },
        success: {
          simple: ' est restauré',
          multi: ' sont restaurés',
        }
      },
      deleting: {
        title: {
          simple: "Voulez-vous supprimer définitivement ce direct ?",
          multi: 'Voulez-vous supprimer définitivement ces directs ?',
        },
        subtitle: {
          simple: " sera supprimé définitivement",
          multi: " seront supprimés définitivement",
        },
        success: {
          simple: ' est supprimé',
          multi: ' sont supprimés'
        }
      },
      checked_elements: 'Les éléments sélectionnés',
      flow: 'Aperçu du direct'
    },
  },
  calendar: {
    title: 'Calendrier',
    allDay: 'Toute la journée',
    back: 'Retour à la liste',
    statistics: 'Statistiques',
    view: 'Visualiser',
    edit: 'Editer',
    period: {
      show: 'Afficher par',
      week: 'Semaine',
      month: 'Mois',
      day: 'Jour',
      today: "Aujourd'hui",
    },
    months: {
      january: 'janvier',
      february: 'février',
      march: 'mars',
      april: 'avril',
      may: 'mai',
      june: 'juin',
      july: 'juillet',
      august: 'aout',
      september: 'septembre',
      october: 'octobre',
      november: 'novembre',
      december: 'décembre',
    },
  },
  form_live: {
      consent: {
        title: "Enregistrement de la visioconférence",
        noConsent: "Sans consentement",
        withConsent: "Avec consentement des participants"
      },

    tabs: {
      pick_video: 'Veuillez choisir une vidéo',
      required_message: 'Ce champ est obligatoire',
      error_long_message: 'Message ne doit pas dépasser 255 caractères',
      general: {
        title: 'Général',
        form: {
          title: 'Titre',
          description: 'Description',
          types:"Type d'affichage",
          type_default:"Par défaut",
          add_image: 'Ajouter une vignette',
          description_image: "Taille d'image recommandée: 1280 x 720",
          edit_image: 'Modifier',
          delete_image: 'Supprimer',
          start_date: 'Date de début',
          end_date: 'Date de fin',
          start_hour: 'Heure de début',
          end_hour: 'Heure de fin',
          tags: 'Tags',
          themes: 'Thèmes',
          invalid_date: 'Date invalide',
          invalid_hour: 'Heure invalide',
          access_live: "Modes d'accès au direct",
          access_free: 'Accès libre',
          access_secure: 'Accès sécurisé',
          placeholder_pass: 'Saisissez votre mot de passe',
          secure_pass: 'Générer un mot de passe sécurisé',
          schedule_live: 'Planifier le direct',
          share_live: {
            title: 'Lien de partage du direct',
            copy: 'Copier',
          },
          archived_live: 'Archivage automatique du direct',
          duration: 'Durée',
          video: {
            visible: 'Vidéo visible',
            invisible: 'Vidéo non visible',
          },
          publish: "Droits d'édition",
          multimedia_options: 'Options multimédia du direct',
          interactives_options: {
            title: 'Options interactives du direct',
            social_media: {
              fb: 'Diffusion en direct sur votre page Facebook',
              youtube: 'Archivage de la vidéo sur votre chaine Youtube',
            },
          },
          infos: {
            vignette: "cliquez sur l'icone pour modifier la vignette de votre vidéo",
            archived_live:
              'Votre direct sera automatiquement archivé et disponible en visualisation vidéo à la demande',
            access_free:
              "Le direct sera visible sans mot de passe, ni autre procédure d'accès sécurisé)",
            access_secure:
              'Le direct sera accessible avec le mot de passe que vous saisissez ci-dessous',
            secure_pass: 'Un mot de passe sera généré pour chaque invitation par mail',
            share_live: 'Le lien comprend le titre de votre conférence',
            themes:
              "Le thème s'applique pour les vidéos à la demande, vous pouvez choisir un ou plusieurs thèmes",
            rich_media: "Cette option permet d'associer des images synchronisées avec la vidéo",
            attaching_files: "Cette option permet d'ajouter des documents téléchargeables",
            tags: "Les mots clés permettent d'améliorer le référencement des vidéos",
          },
        },
      },
      configuration: {
        title: 'Configuration',
        form: {
          infos_live: "Affichage d'informations avant le direct ",
          message: {
            title: 'Message',
            description: 'Message (affiché sur la page du direct)',
          },
          video: {
            title: 'Vidéo',
            description: 'Rechercher...',
          },
          image: 'Image',
          countdown: 'Comptes à rebours',
          title: 'Personnalisé',
          title_before_live: 'Titre(affiché sur la page du direct)',
          title_live: 'Titre du direct',
          description: 'Texte de description',
          description_before_live: 'Description (affichée sur la page du direct)',
          text: 'Texte',
          text_before_live: 'Texte avant live',
          skins_live: 'Sélection du template de la page du direct',
          more: 'Afficher tout',
          less: 'Afficher moins',
          contact: 'Contact',
          informations: 'Informations complémentaires du direct',
          about: 'A propos',
          intervenants: {
            title: 'Intervenants',
            add: 'Ajouter intervenant',
            firstName: 'Prénom',
            lastName: 'Nom',
            fonction: 'Fonction',
            email: 'Email',
            biography: 'Biographie',
          },
          email: 'Email',
          phone: 'Téléphone',
          address: 'Addresse',
          send_invitations: {
            title: 'Envoi des invitations au direct',
            group_emails: 'Groupe',
            emails: 'Email',
          },
          send_rule: {
            title: "Règle d'envoi",
            days_left: 'Jour(s) avant le live à',
            add_rule_button: 'Ajouter une règle',
          },

          encoding: {
            title: "Options d'encodage ",
            url: 'URL du flux de direct',
            name: 'Nom du flux de direct',
            key: 'Clé de sécurisation (option)',
          },
          infos: {
            skins_live: 'Vous pouvez éditer les templates dans la fonction "Web site"',
            message: 'Texte affiché avant la diffusion du direct',
            video: 'Vidéo affichée avant la diffusion du direct',
            image: 'Image affichée avant la diffusion du direct',
            about: 'S\'affiche dans la page du lien "À propos"',
            contact: 'S\'affiche dans la page du lien "Contact"',
            intervenants: 'S\'affiche dans la page de direct (dans le lien "Description"',
            group_emails:
              'Un groupe est un ensemble de mail, les groupes sont éditable dans la fonction "Email"',
            send_rule:
              "Vous pouvez définir une ou plusieurs règle afin d'envoyer des invitations par mail",
            encoding: "Cette option s'applique si vous utilisez un encodeur externe, voir la FAQ",
          },
        },
      },
      advanced: {
        title: 'Paramètres avancés',
        type: {
          title: 'Type du direct',
          intranet: 'Intranet',
          internet: 'Internet',
        },
        diffusion: {
          type_source:"Type d'usage du direct",
          diffusion_social_media:"Diffusion sur réseaux sociaux",
          medias:"Médias",
          title: 'Diffusion',
          title_empreinte: 'Sources',
          webinar: 'Live studio',
          webinar_empreinte: 'Empreinte Live',
          encoding: 'Encodeur manuel',
          sharing: 'Partage écran',
          encodeur_automatique:"Encodeur automatique",
          encoder:"Encodeur",
          encodeur_empreinte:"Encodeur vidéo",
          protocol:"Type de protocole",
          languages:"Langues",
          languages_empreinte:"Multilingue",
          languagesPlaceholder:"Sélectionner les langues",
          countries:"Pays",
          countriesPlaceholder:"Sélectionner les pays",
          addyoutubeLanguage:"AJOUTER CETTE LANGUE",
          emptyInput: "Veuillez saisir une URL YouTube",
          select_station:"Choisissez une station",
          validUrl: "L'URL YouTube saisie n'est pas valide",
          duplicateUrl: "Cette URL est déjà associée à une autre langue",
          ajoute_entree:"(ajouter l'entrée)",
          "language": {
            "orateur": "Orateur",
            "FL1": "Floor Langue",
            "FL2": "Floor Langue 2",
            "Français": "Français",
            "Anglais" : "Anglais",
            "ES": "Espagnol",
            "RU":"Russe",
            "AR":"Arabe",
            "ZH":"Chinois",
            "Autres": "Autres"
          },
          index_audio_port:"Index audio port",
          index_video_port:"Index vidéo port",
          externalHlst: "Hls externe",
          screen_share: {
            pip: 'Picture in Picture PIP',
            sbs: 'Side by Side',
          },
          type: {
            title: "Choix de webinar ",
            title_empreinte: "Accès Empreinte Live",
            by_link: "Url par utilisateur",
            by_link_empreinte:"Accès privé individuel",
            private: " Privé",
            private_empreinte:"Accès privé",
            public: "Public",
            public_empreinte:"Accès public"
          },
	          connexion: {
	            title: "Type de connexion",
	            title_empreinte:"Connexion",
	            auto: "Automatique",
	            auto_description: "Accès direct choix par défaut",
	            by_authorization: "Avec autorisation",
	            by_authorization_description: "Salle d’attente : accès après validation"
	          }
	        },
	        options: {
	          title: 'Options générales',
	          title_empreinte:"Options vidéo",
          private_video: 'Vidéo privée',
          active_video: 'Vidéo Activée',
          automatic_share: 'Publication automatique',
          saveVideo:"Enregister la vidéo"
        },
	        contributors: {
	          header :"Profils",
	          participantTitle:'Participants',
            importMultiParticipants:"Choisissez une ou plusieurs adresses e-mail, ou importez un fichier CSV / Excel.",
	          title: 'Administrateurs',
	          admin_description: "Gestionnaire de la conférence avec contrôle total",
	          participants_description: "Participants à la visioconférence (droits limités)",
	          moderators_description: "Habilité à gérer les commentaires (chat, Q/R)",
	          select_item: 'Appuyez sur enter pour sélectionner',
	          selected_item: 'Sélectionné',
	          delete_item: 'Appuyez sur Entrée pour supprimer',
	          no_result: 'Aucun élément trouvé. Pensez à changer la requête de recherche.',
	          no_options: 'La liste est vide..',
	          add_email:'Ajouter cet e-mail',

	        },
        rich_media: {
          title: 'Richmedia',
          tabs: {
            chapters: {
              title: 'Chapitres',
              empty: 'Pas de chapitres',
              fields: {
                title: 'Titre',
                new: 'Nouveau chapitre',
              },
            },
            questions: {
              title: 'Questions',
              empty: 'Pas de questions',
              add_new: 'Ajouter une question',
              new: 'Nouveau question',
              edit: 'Modifier',
              form: {
                title: 'Question',
                local_questions: {
                  yes_no: 'Oui-Non',
                  yes_no_nsp: 'Oui-Non-NSP',
                  simple_choice: 'Choix simple',
                  multiple_choice: 'Choix multiple',
                  response: 'Réponse',
                  button_add: 'Ajouter',
                },
              },
            },
            slides: {
              title: 'Diapositives',
              edit: 'Modifier',
              delete: 'Supprimer',
              button_show: {
                title: 'Afficher',
                less: 'moins',
                more: 'plus',
              },
            },
          },
        },
                polls: {
          label: 'Sondage',
          title: 'Sondages',
          helper_create_after_save: 'Les sondages seront crees apres l\'enregistrement du direct.',
          loading: 'Chargement des sondages...',
          saving: 'Enregistrement des sondages...',
          empty: 'Aucun sondage pour le moment.',
          add: 'Ajouter un sondage',
          add_first: 'Créer le premier sondage',
          add_hint: 'Ouvrir un nouvel onglet de sondage',
          tab_label: 'Sondage {number}',
          untitled: 'Sondage sans titre',
          options_count: '{count} options',
          incomplete: 'Incomplet',
          editor_hint: 'Modifiez un sondage a la fois tout en gardant la liste visible au-dessus.',
          question_label: 'Question',
          question_placeholder: 'Saisir la question du sondage',
          publish_label: 'Publié automatiquement, visible par tous.',
          option_label: 'Option {number}',
          option_placeholder: 'Saisir une option',
          add_option: 'Ajouter une option',
          existing_hint: 'Les sondages existants peuvent maintenant etre modifies avant enregistrement.',
          delete_poll: 'Supprimer le sondage',
          delete_option: 'Supprimer l\'option',
          confirm_delete_poll: 'Supprimer ce sondage ?',
          confirm_delete_option: 'Supprimer cette option ?',
          min_options_warning: 'Un sondage doit contenir au moins 2 options.',
          delete_option_error: 'Impossible de supprimer cette option du sondage pour le moment.',
          complete_current_first: 'Veuillez completer le sondage en cours avant d en ajouter un nouveau.',
          publish_error: 'Impossible de mettre a jour la visibilite du sondage pour le moment.',
          validation_question_required: 'La question est obligatoire.',
          validation_min_options: 'Chaque sondage doit contenir au moins 2 options.',
          validation_options_required: 'Toutes les options du sondage sont obligatoires.',
        },
        presentation: {
          label: 'Présentation',
          loading: 'Chargement des présentations...',
          uploading: 'Import de la présentation...',
          deleting: 'Suppression de la présentation...',
          empty: 'Aucune présentation pour le moment.',
          upload: 'Importer un document',
          formats_hint: 'PDF, PPTX, DOCX',
          refresh: 'Actualiser',
          open: 'Ouvrir',
          delete: 'Supprimer',
          file: 'Fichier',
          untitled: 'Présentation sans titre',
          slides_count: '{count} slides',
          pending: "En attente de l'enregistrement",
          helper_create_after_save: "Enregistrez d'abord le direct pour pouvoir importer une présentation.",
          queued_success: "Présentation ajoutée. Elle sera importée après l'enregistrement du direct.",
          upload_success: 'Présentation importée avec succès.',
          upload_error: "Impossible d'importer la présentation pour le moment.",
          fetch_error: 'Impossible de charger les présentations pour le moment.',
          delete_success: 'Présentation supprimée avec succes.',
          delete_error: 'Impossible de supprimer cette présentation pour le moment.',
        },
        documents: {
          toggle_label: 'Fichiers partages',
          title: 'Documents partagés (Disponibles sur Empreinte Live)',
          empty: 'Aucun document partagé pour le moment.',
          upload: 'Sélectionner des fichiers à partager',
          refresh: 'Actualiser',
          delete: 'Supprimer',
          publish_default: 'Publier aux auditeurs par défaut',
          pending: 'En attente de l enregistrement',
          private: 'Privé',
          public: 'Public',
          fichier:"Fichier(s)",
          queued_success: "Document ajouté. Il sera importé après l'enregistrement du direct.",
          upload_success: 'Document importé avec succès.',
          upload_error: "Impossible d'importer ce document pour le moment.",
          fetch_error: 'Impossible de charger les documents pour le moment.',
          delete_success: 'Document supprimé avec succès.',
          delete_error: 'Impossible de supprimer ce document pour le moment.',
          publish_error: 'Impossible de mettre à jour la visibilité de ce document pour le moment.',
          uploaded_by: 'Ajouté par',
          unpublish_all: 'Dépublier tous pour les auditeurs',
          unpublish_all_success: 'Tous les documents ont été dépubliés pour les auditeurs.',
          unpublish_all_error: 'Impossible de dépublier tous les documents pour le moment.',
          unpublish_all_nothing: 'Aucun document à dépublier pour les auditeurs.',
          copy_link: 'Copier le lien',
          link_copied: 'Lien du document copié.',
          save_first: 'Les documents seront disponibles après l’enregistrement du direct.',
          visibility: 'Visible pour les auditeurs',
        },
        attaching_files: 'Joindre des fichiers',
        attaching_files_empreinte: 'Fichiers joints',
      },
      frontOffice: {
        title: 'Paramètres SITE WEB',
        "access_page_direct":"Accès à la page de direct",
        lecteur_video:"Lecteur vidéo",
        sous_titrage:"Sous titrage",
        mdp:"Mot de passe",
        inscri_abonne:"Inscription abonnés",
        options: {
          title: 'Options',
          like: "Mention « J’aime »",
          subtitles: 'Sous-titres en temps réel',
          subtitles_empreinte: 'Sous-titres en direct',
          autoTranscription:'Transcription automatique',
          autoTranscription_empreinte:'Sous-titres en différé',
          chat: 'Chat auditeur',
          chat_empreinte:"Chat Web",
          privateChat: "Chat régie",
          privateChat_empreinte:"Chat privé",
          sharing_files: 'Documents partagés',
          sharing_files_live_event: { text: 'Visible sur la page Live streaming', explanation: '' },
          sharing_files_emails: 'Envoyé par mail (lien)',
          sharing_files_studio_live: { text: 'Disponible dans le logiciel de réunion', explanation: '' },
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: "Youtube"
          },
          interactive_tools: {
            title: 'Outils interactifs',
            outils:"Outils",
            whiteBoard: 'Tableau blanc',
            survey: 'Sondage',
            question: 'Question',
            excel: 'Excel',
            autoSip: 'Appel SIP'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage',
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'Avec réponses',
            questionsBeforeLive: 'Questions avant le direct',
          },
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)',
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...',
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage",
          },
        },
      },



      Program: {
        title: 'Programmes et Intervenants',
        new_title:'Programme',
        ParticpantsLimit: 'Limite des participants',
        LiveProgram: 'Programme du direct',
        LiveProgramDescription: 'hh:mm - hh:mm \nTitre et description du sujet',
        MaxParticipantsDistance: 'Max participants à distance',
        MaxInvited: 'Max des invités présents',
        Intervenants: 'Intervenants',
        AddParticipant: 'Ajouter un intervenant',
        editParticipant: 'Modifier un intervenant',
        Photo: 'Photo',
        Cliquez: 'Cliquez pour télécharger',
        Nom: 'Nom',
        Prenom: 'Prénom',
        Fonction: 'Fonction',
        Structure: 'Structure',
        Email: 'Email',
        Annuler: 'Annuler',
        Ajouter: 'Ajouter',
        Inscription: 'Inscription',
        Description: "Description",
        Role: "Role",
        options: {
          title: 'Options',
          like: "Mention j'aime",
          chat: 'Chat',
          sharing_files: 'Documents partagés',
          social_media: {
            title: 'Réseaux sociaux',
            twitter: 'Twitter',
            fb: 'Facebook',
            wisembly: 'Wisembly',
            youtube: 'Youtube'
          },
          secure_pass: 'Sécurisé avec mot de passe',
          registration: {
            title: 'Inscription des abonnés',
            poll: 'Sondage',
          },
          active_comment: {
            title: 'Q&A',
            confirm: 'Avec confirmation',
            replies: 'Avec réponses',
          },
        },
        configuration: {
          title: 'Configuration Front office',
          default: 'Par défaut',
          personalized: {
            title: 'Personnalisé',
            title_before_live: 'Titre(affiché sur la page du direct)',
            title_live: 'Titre du direct',
            description: 'Texte de description',
            description_before_live: 'Description (affichée sur la page du direct)',
            text: 'Texte',
            text_before_live: 'Texte avant live',
            message: {
              title: 'Message',
              description: 'Message (affiché sur la page du direct)',
            },
            video: {
              title: 'Vidéo',
              description: 'Rechercher...',
            },
            image: 'Image',
            countdown: 'Comptes à rebours',
            pearl: "Station d'encodage",
          },
        },
      },
      SkinModel: {
        title: "Modèle d'affichage",
        new_title:"Page Web",
        selectOrCreate: "Sélectionner un modèle existant ou en créer un nouveau",
        choose: "Choisir…",
        selectedSkin: "Modèle appliqué à ce direct est:",
        createNew: "Créer un nouveau modèle",
        existingSkins:"Modèles créés",
        explanation: "Vous pouvez réutiliser un modèle déjà utilisé dans une autre live.",
        newSkin: "Créer un nouveau modèle",
        primaryColor: "Couleur primaire",
        secondaryColor: "Couleur secondaire",
        primaryTextColor: "Couleur texte primaire",
        secondaryTextColor: "Couleur texte secondaire",
        liveTitle: "Titre à afficher",
        logo: "Logo",
        beforeAfterInfo: "Infos avant/après live",
        beforeLiveInfo: "Infos avant le live",
        afterLiveInfo: "Infos après le live",
        infoText: "Texte",
        showDate: "Afficher la date",
        showHour: "Afficher l'heure",
        backgroundImage: "Image de fond",
        blurred: "Flouté",
        skinName: "Nom du modèle",
        addAndApply: "Appliquer",
        applySkin:"Modifier",
        editNote:"NB : La modification du modèle impactera les directs possédant le même modèle."

      }
,  





    },
  },
  upload_files: {
    title: 'Glisser et déposer',
    image_type: ' un image ici',
    file_type: ' un fichier ici',
    media_type: ' un media ici',
    or: 'ou ',
    click: 'cliquer',
    selected_file: ' pour sélectionner un fichier de votre ordinateur',
  },
  vignette: {
    confirm: 'confirmer',
    edit: 'Modifier',
    delete: 'Supprimer',
    streaming_wrapper: 'STREAMING EN DIRECT',
  },
  toast: {
    success_delete: 'Élément supprimé avec succès!',
    success_add: 'Direct crée avec succès!',
    success_diffusion: 'La diffusion a été effectué avec succés',
    success_edit: 'Direct mis à jour avec succés!!',
    error: 'Une erreur est survenue, veuillez réessayer.!',
    success_send: 'Invitation envoyé avec succès!',
    success_send_link: 'Lien envoyé avec succès!',
    success_download: 'Direct téléchargé avec succès!',
    'not-exist': "Fichier n'existe pas!",
    no_emails_provided: 'Aucun e-mail fourni',
    no_date_provided: 'Aucune date fournie',
    export_success: "Fichier exporté avec succès",
    export_Error: "Erreur lors de l'exportation du fichier Excel",
    export_empty: "Aucune donnée existante à exporter.",
    DeleteError: "Erreur lors de la suppression de l'intervenant",
    UpdateError: "Erreur lors de la modification du participant",
    AddError: "Une erreur s'est produite lors de l'ajout du participant",
    getModeratorsError: "Une erreur s'est produite lors de la récupération des modérateurs",
    export_questions_success: "Questions exportées avec succès",
    no_questions_to_export: "Aucune question à exporter",
    export_questions_error: "Une erreur s'est produite lors de l'exportation des questions",
  },
  date: {
    placeholder: 'Sélectionnez une date',
  },
  statut: {
    Archive: "Archivé",
    Live: "En direct",
    Waiting: "En attente",
    error: ""
  },
  startDirect: {
    title: 'Confirmation ',
    subtitle: "Voulez-vous commencer le direct maintenant?",
    choix: 'Cochez cette case pour définir ce choix par défaut et ne plus afficher cette fenêtre.',
    btn: {
      YES: 'OUI',
      NO: 'NON'
    }
  },
  shareLink: {
    from: "De",
    to: "Envoyer à ",
    selected: "Sélectionné",
    link: "Lien",
    password: "Mot de passe",
    secure_password: "Générer un mot de passe sécurisé ",
    send_plan: "Planifier l'envoi",
    planifier: "Planifier",
    date_plan: "L'envoi sera planifier à la date spécifié ",
    journalist: "Prompteur",
    moderator: "Modérateur",
    listener: "Auditeur",
    participant: "Participant",
    emails_placeholder: "Entrez les adresses e-mail des destinataires",
  }
};



// WEBPACK FOOTER //
// ./src/i18n/fr_FR.js